import Profiler from "./profiler";

export default Profiler;
